import { clsx } from 'clsx'

import { EmailLog } from '@tribeplatform/gql-client/types'
import { T, useStaticIntl } from '@tribeplatform/react-components/i18n'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { emailStatusMappingFactory } from './constants.js'

interface EmailStatusRenderedProps {
  emailLog: EmailLog
}

// This component does not contain any translatable texts
// eslint-disable-next-line react/jsx-no-literals
const emptyStatus = <>-</>

export const EmailStatusRenderer = ({ emailLog }: EmailStatusRenderedProps) => {
  const emailStatusMapping = useStaticIntl(emailStatusMappingFactory)

  if (!emailLog) {
    return emptyStatus
  }

  const { reason, createdAt, status } = emailLog
  const emailStatus = emailStatusMapping[status]
  const { className, title, description } = emailStatus

  if (!emailStatus) {
    return emptyStatus
  }

  if (new Date(createdAt) < new Date('2022-03-01')) {
    return emptyStatus
  }

  return (
    <div>
      <Tooltip>
        <Tooltip.Trigger
          className={clsx('font-medium inline-block', className)}
        >
          {title}
        </Tooltip.Trigger>
        <Tooltip.Panel>
          <div>{description}</div>
          {reason ? (
            <div className="mt-2">
              <T
                defaultMessage="Reason: {reason}"
                id="Admin.EmailLog.ReasonTemplate"
                values={{
                  reason,
                }}
              />
            </div>
          ) : null}
        </Tooltip.Panel>
      </Tooltip>
    </div>
  )
}
